import { TriState } from './secondary-filter-row';

// Initial value of the "Mobile App" segmented control on the POM Users list.
//
// 'all' on purpose (ClickUp 868m7cqz8, Suzanne 2026-09-21). The redesign had
// carried the old "Registered" tab's scope forward as a 'yes' default, which
// hid pending (not-yet-registered) users on first load: admins searched for a
// user they had just invited, saw no rows, and assumed the user did not
// exist. Support was telling every caller to flip the control to "All" before
// searching, and one of the main reasons admins open this page is to find out
// a user's status, so the page has to show everyone until they narrow it.
export const DEFAULT_APP_FILTER: TriState = 'all';

// The API's showActiveUsers query param is tri-state: true = registered
// (has the app), false = pending, omitted = both. Only 'yes'/'no' set it.
export const triToShowActiveUsers = (v: TriState): boolean | undefined => {
    if (v === 'yes') return true;
    if (v === 'no') return false;
    return undefined;
};
